import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { map, take, tap } from 'rxjs/operators';

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    take(1),
    map(user => !user), // Allow if NO user (guest)
    tap(isGuest => {
      if (!isGuest) {
        router.navigate(['/dashboard']);
      }
    })
  );
};
